import React from 'react';
import { connect } from 'react-redux';
import { FragmentHeaderRoundTrip } from './types/FragmentHeaderRoundTrip';
import { FragmentHeaderSegment } from './types/FragmentHeaderSegment';
import { TripType, SearchProp, TabTypeProp, TabTypePropDefault } from '../../../../models';
import { withPageContext } from '../../../../utils';

export const FieldHeader = ({ currentSearch, activeProduct }) => {
    if (currentSearch.tripType === TripType.ROUND_TRIP) {
        return <FragmentHeaderRoundTrip segments={currentSearch.segments} activeProduct={activeProduct} />;
    }

    return <FragmentHeaderSegment />;
};

FieldHeader.propTypes = {
    currentSearch: SearchProp.isRequired,
    activeProduct: TabTypeProp,
};
FieldHeader.defaultProps = {
    activeProduct: TabTypePropDefault,
};

const mapStateToProps = ({ currentSearch, activeProduct }) => ({
    currentSearch,
    activeProduct: activeProduct.activeProduct,
});

export const ConnectedFieldHeader = connect(mapStateToProps)(withPageContext(FieldHeader));
